import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import axios from 'axios';
// import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'

// Containers.
import AppContainer from 'containers/AppContainer';

// Store.
import configureStore from 'store';

// Utils.
import { getLanguage } from 'utils';

// Languages.
import locales from 'locales';

// Config.
const { apiURL } = window.CONFIG_ENV;

// Current browser language.
const language = getLanguage();

axios.defaults.baseURL = apiURL;
axios.defaults.withCredentials = true;

axios.defaults.headers.common['Accept-Language'] = language;

// ReactGA.initialize('UA-70888505-4', { allowLinker: true, domains: ['welltory.com'] });
const tagManagerArgs = {
  gtmId: 'GTM-WN829F3'
};

TagManager.initialize(tagManagerArgs);

const initialState = window.__initialState__ || undefined;
// const initialState = undefined;

const history = createBrowserHistory();

const store = configureStore(initialState, history);

syncTranslationWithStore(store, history);

store.dispatch(loadTranslations(locales));
store.dispatch(setLocale(language));

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppContainer />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
